import {
  FetchSelectableTrafficPeriodsSuccess,
  TrafficPeriodSelectionActions,
  TrafficPeriodSelectionActionTypes
} from '@app/pcs/actions/traffic-period-selection';
import { TrafficPeriod } from '@app/pcs/models';
import { createHandler, createReducer } from '@app/util';

export type State = TrafficPeriod[];

export const initialState: State = [];

// Handlers
const fetchSelectableTrafficPeriodsSuccess = (state: State, {payload}: FetchSelectableTrafficPeriodsSuccess): State =>
  payload;

const fetchSelectableTrafficPeriodsSuccessHandler = createHandler(
  TrafficPeriodSelectionActionTypes.FetchSelectableTrafficPeriodsSuccess,
  fetchSelectableTrafficPeriodsSuccess
);

export const reducer = createReducer<State, TrafficPeriodSelectionActions>([
  fetchSelectableTrafficPeriodsSuccessHandler
], initialState);
